<template>
    <button @click="reset()" type="button" class="btn btn-sm btn-success btn-block" v-if="enable">
        <li class="fa fa-recycle"></li> SZCS#SLPDISCONNECT=1
    </button>
    <button @click="reset()" type="button" class="btn btn-sm btn-danger btn-block" v-else>
        <li class="fa fa-recycle"></li> SZCS#SLPDISCONNECT=0
    </button>
</template>
<script>
    import { Comandos } from '../../../../class';
    import { Bus } from '../../../../class/bus';
    export default {
        name: 'SleepOneblock',
        props: {
            id_rastreador: {
                "default": null
            },
            enable: {
                "default": false
            }
        },
        methods: {
            async reset () {
                await Comandos.habilitarSleep(this.id_rastreador, this.enable);
                Bus.$emit('comandos');
            }
        }
    }
</script>
